import { useState, useEffect } from "react";
import { db, auth } from "../../firebase";
import Card from "./card";

export default function Apps({ onDelete }) {
  const [user, setUser] = useState(null);
  const [apps, setApps] = useState([]);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged((u) => {
      setUser(u);
    });

    return unsub;
  }, []);

  useEffect(() => {
    let unsub;
    if (user) {
      db.collection("apps")
        .where(`members.${user.uid}`, "!=", null)
        .onSnapshot((snap) => {
          setApps(snap.docs.map((x) => ({ ...x.data(), id: x.id })));
        });
    }
    return unsub;
  }, [user]);

  return (
    <div style={{ display: "flex" }}>
      {apps.map((app) => {
        return (
          <Card onDelete={() => onDelete(app.id)} app={app} key={app.id} />
        );
      })}
    </div>
  );
}
